import Vue from "vue";

const baseUrl = "https://new.gongjiayun.cn/";
Vue.prototype.baseUrl = baseUrl;
export default baseUrl;



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 